import { render } from "./Manufacturer.vue?vue&type=template&id=5455e49e&scoped=true"
import script from "./Manufacturer.vue?vue&type=script&lang=js"
export * from "./Manufacturer.vue?vue&type=script&lang=js"

import "./Manufacturer.vue?vue&type=style&index=0&id=5455e49e&scoped=true&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/play-spider-web-prod-s3-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5455e49e"]])

export default __exports__